<template>

<el-container id="app" style="min-width: 1080px;">
	
	
<aligner></aligner>
	
	
  </el-container>
</template>

<script>
import Aligner from './components/Aligner.vue'
import cnHeader from './components/Header.vue'
import  './assets/css/main.css'
export default {
  name: 'app',
  components: {
	Aligner,
	cnHeader
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
</style>
